var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mp-hero-wrapper"
  }, [_c('div', {
    staticClass: "mp-hero"
  }, [_c('MPPromoSlider', {
    staticClass: "mp-hero__slider",
    attrs: {
      "list": _vm.data.dataSource.data.sale || []
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _el$image, _el$image2, _el$image3, _el$mobileImage, _el$mobileImage2, _el$mobileImage3;

        var el = _ref.el;
        return [_c('GGLink', {
          staticClass: "mp-hero__slide",
          attrs: {
            "to": el.path
          }
        }, [_c('img', {
          staticClass: "slide__img slide__img_desktop",
          attrs: {
            "src": (_el$image = el.image) === null || _el$image === void 0 ? void 0 : _el$image.x1,
            "srcset": ((_el$image2 = el.image) === null || _el$image2 === void 0 ? void 0 : _el$image2.x2) && (((_el$image3 = el.image) === null || _el$image3 === void 0 ? void 0 : _el$image3.x2) + " 2x"),
            "alt": el.name
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "slide__img slide__img_mobile",
          attrs: {
            "src": (_el$mobileImage = el.mobileImage) === null || _el$mobileImage === void 0 ? void 0 : _el$mobileImage.x1,
            "srcset": ((_el$mobileImage2 = el.mobileImage) === null || _el$mobileImage2 === void 0 ? void 0 : _el$mobileImage2.x2) && (((_el$mobileImage3 = el.mobileImage) === null || _el$mobileImage3 === void 0 ? void 0 : _el$mobileImage3.x2) + " 2x"),
            "alt": el.name
          }
        })])];
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "mp-hero__cards"
  }, [_c('div', {
    staticClass: "mp-hero__card mp-hero__card_how",
    on: {
      "click": _vm.openStories
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('GGLink', {
    staticClass: "mp-hero__card mp-hero__card_seller",
    attrs: {
      "to": _vm.promoLink
    }
  }, [_c('p', {
    staticClass: "card__text"
  }, [_vm._v("\n          Хотите "), _c('br'), _vm._v("\n          продавать "), _c('br'), _vm._v("\n          на маркете?\n        ")])])], 1)], 1), _vm._v(" "), _vm.preview ? _c('Teleport', {
    attrs: {
      "to": "body"
    }
  }, [_c('MPStories', {
    attrs: {
      "stories": _vm.data.dataSource.data.story,
      "active": _vm.activeStories
    },
    on: {
      "close": function ($event) {
        return _vm.closeStories();
      }
    }
  })], 1) : _c('MPStories', {
    attrs: {
      "stories": _vm.data.dataSource.data.story,
      "active": _vm.activeStories
    },
    on: {
      "close": function ($event) {
        return _vm.closeStories();
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "card__text"
  }, [_vm._v("\n          Как работает "), _c('br'), _vm._v("\n          маркет?\n        ")]);
}]

export { render, staticRenderFns }